import PropTypes from 'prop-types'


const measurePluvioType = PropTypes.shape({
    pluvioId: PropTypes.number, // Int,
    dataType: PropTypes.number, // Int,
    date: PropTypes.number, // DateTime,
    initialValue: PropTypes.number, // Option[Double],
    value: PropTypes.number, // Option[Double],
    measureMode: PropTypes.string, // Option[String],
    status: PropTypes.number, // Option[Int],
    qualification: PropTypes.number, // Option[Int],
    nature: PropTypes.string, // Option[String],
    initialPoint: PropTypes.string, // Option[String],
    validator: PropTypes.number, // Option[Int],
    manager: PropTypes.number, // Option[Int],
    producer: PropTypes.number, // Option[Int],
    jobExecutionId: PropTypes.number, // Option[Int],
    importDate: PropTypes.number, // Option[DateTime],
    updateDate: PropTypes.string, // Option[String],
    updateLogin: PropTypes.string, // Option[String]
    codepoint: PropTypes.string, // Option[String]
})

const validationSelectFiltersType = PropTypes.shape({
    filterStatus: PropTypes.number,
    filterQualification: PropTypes.number,
    filterProducer: PropTypes.number,
    filterManager: PropTypes.number,
    filterValidator: PropTypes.number,
    filterSuperior: PropTypes.number,
    filterInferior: PropTypes.number,
})

export { measurePluvioType, validationSelectFiltersType }
